<template>
  <div>
    <v-hover>
      <template v-slot:default="{ hover }">
        <div class="image-container rounded-lg">
          <v-img class="rounded-lg" aspect-ratio="1" :src="imageUrl" :width="80" :height="80"></v-img>

          <v-fade-transition>
            <v-overlay v-if="hover" absolute>
              <v-btn icon color="white" @click.stop="showDialog = true">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </v-overlay>
          </v-fade-transition>
        </div>
      </template>
    </v-hover>

    <v-dialog v-model="showDialog" persistent max-width="600px">
      <div style="position: relative;">
        <v-img :src="imageUrl" contain></v-img>
        <v-btn icon color="white" class="close-btn" @click="showDialog = false" style="position: absolute; right: 0; top: 0; z-index: 1;">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import config from '@/common/config';

export default {
  name: 'ResultImage',
  mixins: [common, configMixin],
  props: {
    filename: String,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    imageUrl() {
      return this.filename ? `${config.apiUrl}/medias/begleitfahrt/media/${this.filename}` : '';
    },
  },
};
</script>
<style scoped>
.image-container {
  position: relative;
  width: 80px;
  height: 80px;
  display: inline-block;
}
</style>
